// extracted by mini-css-extract-plugin
export var details = "project-details-module--details--1tNzN";
export var html = "project-details-module--html--3YwDw";
export var featured = "project-details-module--featured--3OUDF";
export var feature_img = "project-details-module--feature_img--A7848";